import React from 'react'
import styled from 'styled-components'
import Layout from '../system/layout'
import PACHero from '../system/generic-hero/pac-hero'
import Container from '../system/container/container'
import Meta from '../system/meta'

const StyledContainer = styled(Container)`
  h2 {
    margin-top: ${props => props.theme.spacing.base700};
    margin-bottom: 0;
  }
`

const ContactPage = ({ title, children }: { title: string; children: any }) => (
  <Layout>
    <Meta title={title} />
    <PACHero>
      <h1>
        <b>Contact</b> Us
      </h1>
    </PACHero>
    <StyledContainer>{children}</StyledContainer>
  </Layout>
)

export default ContactPage
